// Setting.js
import React from 'react';
import './Settings.css'; // Import the CSS file

const Settings = () => {
    return (
        <div className="Settings">
            <h1>Welcome to My Settings Page</h1>
            <p>This is a simple page with a background color.</p>
        </div>
    );
};

export default Settings;